<div class="body-container-wrapper">
  <section class="retirement-home-page-banner p-0">
    <div class="container-fluid" style=" margin-bottom: 10px;">
      <div class="row align-items-start">
         <div class="col-md-8 col-sm-12">
                    <figure>
                        <img src="../../assets/images/sip-campaign/desktop.webp" alt="sip-campaign" class="banner-img" (click)="desktopscroll()"  style="cursor: pointer;">
                    </figure>
                </div>
        <!-- Form Section -->
        <div class="col-md-4 col-sm-12">
          <div class="card banner-form">
            <div class="card-body" *ngIf="isLeadFormVisible">
              <h3 class="form-title">Fill the below form
to start a SIP</h3>
              <p id="fill-form" style="color: #ed1b24; display: none;">Fill in all the details to proceed further.</p>
              <form #leadForm="ngForm" (ngSubmit)="PostData(leadForm)">
                <div class="form-group">
                  <label for="">Name<span class="asterisk"></span></label>
                  <input type="text" autocomplete="off" id="name" name="name" [(ngModel)]="name" class="form-control"
                    (blur)="removeErrorMsg('name')" placeholder="Please enter your full name" maxlength="40"
                    inputmode="text"
                    oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');"
                    (keydown)="alphaOnly($event)">
                  <div class="errormsg" *ngIf="nameValidateMessage == 'lengthError'">
                    Invalid full name
                  </div>
                  <div class="errormsg" *ngIf="nameValidateMessage == 'required'">
                    Full name is mandatory
                  </div>
                </div>
                <div class="form-group">
                  <label for="">Email Addresss </label>
                  <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();" id="email"
                    name="email" [(ngModel)]="email" class="form-control" placeholder="Your email id" maxlength="50"
                    (blur)="removeErrorMsg('email')">
                  <div class="errormsg" *ngIf="emailValidateMessage == 'invalid'">
                    Invalid email id
                  </div>
                  <div class="errormsg" *ngIf="emailValidateMessage == 'required'">
                    Email id is mandatory
                  </div>
                </div>
                <div class="form-group">
                  <label for="">Mobile Number<span class="asterisk"></span></label>
                  <input type="text" (keydown.space)="$event.preventDefault();" autocomplete="off" id="mobile"
                    name="mobile" [(ngModel)]="mobile" class="form-control" placeholder="Enter Your mobile number"
                    minlength="10" maxlength="10" pattern="[6789][0-9]{9}" (blur)="removeErrorMsg('mobile')"
                    inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                    (keypress)="numbersOnly($event)">
                  <div class="errormsg" *ngIf="mobileValidateMessage == 'lengthError'">
                    10 digit mobile number is mandatory
                  </div>
                  <div class="errormsg" *ngIf="mobileValidateMessage == 'invalid'">
                    Invalid mobile number
                  </div>
                  <div class="errormsg" *ngIf="mobileValidateMessage == 'required'">
                    Mobile number is mandatory
                  </div>
                </div>

                <div class="form-group">
                  <label for="">City <span class="asterisk"></span></label>
                  <input type="text" autocomplete="off" id="city" name="city" [(ngModel)]="city" class="form-control"
                    placeholder="Your city" maxlength="40" (keydown)="alphaOnly($event)" (blur)="removeErrorMsg('city')"
                    inputmode="text"
                    oninput="this.value = this.value.replace(/[^a-zA-Z\s]/g, '').replace(/\s{2,}/g, ' ');">

                  <!-- city dropdown -->
                  <!-- <select class="selected-item  form-control" [(ngModel)]="cityModel" name="city"
                                        (ngModelChange)="ValidateCity()" #city>
                                        <option selected disabled value="">Select City/District</option>
                                        <option *ngFor="let city of cityList;" [value]="city['name']+'-'+city['Id']">
                                            {{city['name']}}
                                        </option>
                                        </select> -->

                  <div class="errormsg" *ngIf="cityValidateMsg == 'required'">
                    City is mandatory
                  </div>
                </div>

                <div class="form-group">
                  <label for="">Pincode <span class="asterisk"></span></label>
                  <input type="text" autocomplete="off" id="pincode" name="pincode" [(ngModel)]="pincode"
                    class="form-control" placeholder="Your pincode" pattern="^[1-9][0-9]{5}$" minlength="6"
                    maxlength="6" (click)="openSuggestionBox($event,'form')" (blur)="hideSuggestionDiv('form')"
                    (keyup)="getPincodeList($event,'form')" (keypress)="numberspincode($event)">
                  <div class="errormsg" *ngIf="pinValidateMessage== 'invalid'">
                    Invalid pincode
                  </div>
                  <div class="errormsg" *ngIf="pinValidateMessage == 'required'">
                    Pincode is mandatory
                  </div>
                  <div class="errormsg" *ngIf="pinValidateMessage == 'notselected'">
                    Pincode selection from the list is mandatory
                  </div>

                  <div class="suggestion-box" id="suggestion-box" *ngIf="hideSuggestion">
                    <ng-container *ngFor="let pin of pincodeArr">
                      <a class="pointer" (mousedown)="setpincode(pin,'form')">
                        <div style="padding:10px;">{{pin.pincode}} - {{pin.cityname}}</div>
                      </a>
                    </ng-container>
                  </div>
                </div>



                <div class="form-group">
                  <label for="">Current Age</label>
                  <input type="text" class="form-control" placeholder="Enter in years" id="currentAge"
                    [(ngModel)]="currentAge" name="currentAge" autocomplete="off"
                    (blur)="removeErrorMsg('currentage')" minlength="" maxlength="3"
                    (keypress)="numberspincode($event)">
                  <div class="errormsg" *ngIf="currAgeValidateMessage == 'invalid'">
                    Current age is not valid
                  </div>
                  <div class="errormsg" *ngIf="currAgeValidateMessage == 'required'">
                    Current age is mandatory
                  </div>
                </div>
                <div class="text-left position-relative pl-3">
                  <input type="checkbox" class="form-check-input checkbox2" id="checkout1" [(ngModel)]="checkedTerms"
                    name="check" />
                  <small class="whatsappcontent">
                    By continuing to use this Site/Page, you acknowledge and consent to receiving promotional or
                    sales-related communications from BajajCapital Group. These communications may be sent via phone
                    calls, SMS, WhatsApp, or email, using the contact details you have provided on the Site/Page.
                  </small>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary" [disabled]="!checkedTerms"
                    (click)="checkValidationMsg(leadForm)">Submit</button>
                </div>
              </form>
            </div>
            <div class="card-body otp-card" *ngIf="isOtpFormVisible">
              <div id="main_loader" style="display:none;">
                <div class="loader-wrapper">
                  <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </div>
              <!-- <h4 class="form-title">Maximize Your Tax Savings Now!</h4> -->
              <form #otpForm="ngForm" (ngSubmit)="SubmitOTP(otpForm)">
                <p><a href="javascript:void(0)" id="btn-back" (click)="changeNumber()" style="color: #ed1b24;"><i
                      class="fa fa-chevron-left"></i> Change Number</a></p>
                <div class="alert alert-success">
                  <i class="fa fa-check"></i>
                  <span>OTP successfully sent on number {{displayMobile}}</span>
                </div>
                <div class="form-group">
                  <input type="text" autocomplete="off" (keydown.space)="$event.preventDefault();"
                    (keyup)="removeErrorMsg('otp')" id="otp" name="otp" [(ngModel)]="userOTP" class="form-control"
                    maxlength="6" placeholder="Enter OTP" (keypress)="numberspincode($event)">
                  <div class="errormsg" *ngIf='!otpVerifiedStatus'>
                    Invalid OTP
                  </div>
                  <div class="errormsg" *ngIf="otpValidateMessage == 'required'">
                    Please enter OTP to continue.
                  </div>
                  <div class="errormsg" *ngIf="otpValidateMessage == 'lengthError'">Invalid OTP
                  </div>
                </div>
                <div class="text-center">
                  <button type="submit" class="btn btn-primary" id="otp_verify_btn"
                    (click)="otpValidate()">Submit</button>
                </div>
                <div class="form-group text-center">
                  <span *ngIf="isTimer">Didn't recieve OTP? Resend in <strong style="font-size:17px;">{{timeleft}}
                    </strong>seconds</span>
                  <a class="resendotp" href="javascript:void(0)" *ngIf="isResend" (click)="resendOTP()">Resend OTP</a>
                </div>
              </form>
            </div>
            <div class="card-body success-card" *ngIf="isThanksVisible">
              <div class="success-tick">
                <h2>Thank you!</h2>
              </div>
              <h6>{{ thanksMessage }}</h6>
            </div>

          </div>
        </div>
        <!-- old form end  -->
      </div>
    </div>
  </section>

  
  <!-- Calendar Popup Modal -->
  <div class="calendar-popup-overlay" *ngIf="isCalendarPopupVisible">
    <div class="calendar-popup-content" (click)="$event.stopPropagation()">
      <div class="calendar-popup-header">
        {{ isalreadyBooked ? 'THANKYOU!' : 'Schedule Your Consultation' }}
        <button class="close-btn" (click)="closeCalendarPopup()">&times;</button>
      </div>

       
      <div class="calendar-popup-body" *ngIf="isalreadyBooked"> 
  <h4>
    Your appointment has been fixed. We will call you on 
    {{appointmentDate}} at {{appointmentTime}}.
  </h4>
</div>

      <div class="calendar-popup-body" *ngIf="!isalreadyBooked">
        <!-- Date Selection -->
        <div class="calendar-selection-wrapper">
          <div class="date-selection-section">
            <h4>Select Date</h4>

            <!-- Calendar Header -->
            <div class="calendar-header">
              <div class="calendar-nav">
                <button class="nav-btn" (click)="previousMonth()">
                  <i class="fa fa-chevron-left"></i>
                </button>
                <span class="current-month-year">{{currentMonth.format('MMMM YYYY')}}</span>

                <button class="nav-btn" (click)="nextMonth()">
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>

            <!-- Calendar Grid -->
            <div class="calendar-grid">
              <!-- Days of Week Header -->
              <div class="calendar-weekdays">
                <div class="weekday" *ngFor="let day of ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']">
                  {{day}}
                </div>
              </div>

              <!-- Calendar Days -->
              <div class="calendar-days">
                <div *ngFor="let day of calendarDays" class="calendar-day" [class.current-month]="day.isCurrentMonth"
                  [class.other-month]="!day.isCurrentMonth" [class.today]="day.isToday" [class.selected]="day.isSelected"
                  [class.disabled]="day.isDisabled" [class.available]="day.isAvailable"
                  (click)="selectCalendarDate(day)">
                  {{day.date.format('D')}}
                </div>
              </div>
            </div>

            <!-- Calendar Actions -->
            <div class="calendar-actions">
              <button class="clear-btn" (click)="clearSelection()">CLEAR</button>
            </div>
          </div>

          <!-- Time Slot Selection -->
          <div class="time-selection-section" [class.has-selection]="!!selectedDate" *ngIf="selectedDate">
            <div class="time-selection-header">
              <h4>Select Time Slot</h4>
            </div>
            <div class="time-slots">
              <div *ngFor="let timeSlot of availableTimeSlots" class="time-slot"
                [class.selected]="selectedTimeSlot === timeSlot" (click)="selectTimeSlot(timeSlot)">
                {{timeSlot}}
              </div>
            </div>

            <!-- Confirm Button -->
            <div class="popup-actions" *ngIf="isAppointmentReady()">
              <p class="_popmsg">{{popupmessage}}</p>
              <button class="btn btn-primary confirm-btn" (click)="confirmAppointment()" [disabled]="isButtonDisabled">
                Confirm Appointment
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>

<!-- old form end  -->




<section id="sipSection" class="financial-calculators"  *ngIf="currentCalculator === 'sip'" style="
    margin-top: 10px;
    background-color: white;
">
    <div class="container">
        <div class="row position-relative">
          <div class="col-xl-12 col-lg-12 col-md-12">
           
             <div class="left">
              <div class="calculator">
                <div class="sip">
                  <div class="number">
                    <h1 class="heading">SIP Calculator</h1>
                     <div class="chips">
                  <a class="badges active" style="cursor:pointer" (click)="showCalculator('sip')">SIP</a>
                  <a class="badges"style="cursor:pointer" (click)="showCalculator('lumsum')">Lumpsum</a>
                </div>
                    <div class="calculators">
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Monthly investment</p>
                          <div class="tooltiped" id="error_msg">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              amount_errormsg
                            }}</span>
                          </div>
                          <div class="placeholder">
                            <i class="fa fa-inr" aria-hidden="true"></i>
                            <input
                              class="range__amount"
                              id="monthlyInput"
                              name="monthlyInput"
                              [(ngModel)]="Monthly_investment"
                              type="number"
                              value="25000"
                              min="500"
                              max="200000"
                              (input)="
                                setInvestmentValue($event);
                                preventInput($event);calculation();updateChartData(chartData)
                              "
                            />
                          </div>
                        </div>
                        <div class="month_range">
                         <div
                              class="calculator-range-slider calculator-custom-range"
                            >
                              <input
                                type="range"
                                name=""
                                step="500"
                                value="25000"
                                class="input-range calc-result-sliders"
                                min="500"
                                max="200000"
                                 id="monthlyRange"
                                [(ngModel)]="Monthly_investment"
                                (input)="monthlyInvestmentRangeVal()"
                                (change)="calculation(); updateChartData(chartData)"
                              />
                              <span
                              class="type-range"
                              [style.width.%]="(P / 200000) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(P / 200000) * 100"
                            ></span>
                            </div>
                          <div class="values">
                            <p class="value">₹500</p>
                            <p class="value">₹2,00,000</p>
                          </div>
                        </div>


                  
                      </div>
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Expected return rate (p.a)</p>
                          <div class="tooltiped" id="error_msg1">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              Expected_Rate_error
                            }}</span>
                          </div>
                          <div class="placeholder reverse">
                            <i class="percent">%</i>
                            <input
                              class="range__amount"
                              id="monthlyexpect"
                              type="number"
                              value="12"
                              min="1"
                              max="30"
                              [(ngModel)]="monthlyexpect"
                              (input)="
                                setRateValue($event);
                                preventInput($event);calculation();updateChartData(chartData)
                              "
                              
                            />
                          </div>
                        </div>
                        <div class="month_range">
                          <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              step="0.1"
                              class="input-range calc-result-sliders"
                              min="1"
                              max="30"
                              id="monthlyrate"
                              [(ngModel)]="monthlyexpect"
                              (input)="monthlyRateRangeVal()"
                              (change)="calculation(); updateChartData(chartData)"
                            />
                            <span
                              class="type-range"
                              [style.width.%]="(R / 30) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(R / 30) * 100"
                            ></span>
                          </div>
                          <div class="values">
                            <p class="value">1%</p>
                            <p class="value">30%</p>
                          </div>
                        </div>
                      </div>
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Time period</p>
                          <div class="tooltiped" id="error_msg2">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              Time_period_error
                            }}</span>
                          </div>
                          <div class="placeholder reverse">
                            <i class="year">Yr</i>
                            <input
                              class="range__amount"
                              id="timeperiod"
                              type="number"
                              value="10"
                              min="1"
                              max="30"
                              [(ngModel)]="timeperiod"
                              (input)="
                                setTimeValue($event);
                                preventInput($event);calculation();updateChartData(chartData)
                              "
                              
                            />
                          </div>
                        </div>
                        <div class="month_range">
                          <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              id="timerange"
                              step="1"
                              value="10"
                              class="input-range calc-result-sliders"
                              min="1"
                              max="30"
                              [(ngModel)]="timeperiod"
                              (input)="monthlyTimeRangeVal()"
                              (change)="calculation(); updateChartData(chartData)"
                            />
                            <span
                              class="type-range"
                              [style.width.%]="(T / 30) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(T / 30) * 100"
                            ></span>
                          </div>
                          <div class="values">
                            <p class="value">1Yr</p>
                            <p class="value">30Yr</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="data">
                    <div class="graph">
                      <ul class="indicators">
                        <li class="amount">Invested amount</li>
                        <li class="return">Est. returns</li>
                      </ul>
                      <div class="graph_img">
                        <canvas id="myChart" width="260px" height="150px"></canvas>
                        <!-- <img src="../../../assets/images/wish-sip/graph.png" class="img-fluid" alt="graph"> -->
                      </div>
                      <div class="values">
                        <ul class="list">
                          <li class="text">Invested amount:</li>
                          <li class="value">
                            ₹{{ total_investment_ammount | conversions }}
                          </li>
                          <li class="text">Est. returns:</li>
                          <li class="value">
                            ₹{{ estmated_return | conversions }}
                          </li>
                        </ul>
                        <ul class="list total">
                          <li class="text">Total value:</li>
                          <li class="value">
                            ₹{{ calculate_value | conversions }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="invest_btn">
                      <a (click)="scrolltop()" style="cursor: pointer;">
                            <img src="../../../assets/images/wish-sip/Connect-Now-Button.png" alt="Invest Now" style="height:80px;" />
                            </a>
                    </div>
                  </div>
                </div>
                <!-- <div class="lumpsum"></div> -->
              </div>
            </div>
      
          </div>
        </div>
    </div>

</section>



<section class="financial-calculators" *ngIf="currentCalculator === 'lumsum'" style="
    margin-top: 10px;
    background-color: white;
">
    <div class="container">
        <div class="row position-relative">
          <div class="col-xl-12 col-lg-12 col-md-12">      
           <div class="left">
 <div class="calculator">
                <div class="sip">
                  <div class="number">
                    <h1 class="heading">Lumpsum Calculator</h1>
                     <div class="chips">
                  <a class="badges" style="cursor:pointer" (click)="showCalculator('sip')">SIP</a>
                  <a class="badges active" style="cursor:pointer" (click)="showCalculator('lumsum')">Lumpsum</a>
                </div>
                        <div class="calculators">
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Total investment</p>
                          <div class="tooltiped" id="error_msg">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              L_amount_errormsg
                            }}</span>
                          </div>
                          <div class="placeholder">
                            <i class="fa fa-inr" aria-hidden="true"></i>
                            <input
                              class="range__amount"
                              id="monthlyInput"
                              name="monthlyInput"
                              [(ngModel)]="L_Monthly_investment"
                              type="number"
                              value="25000"
                              min="500"
                              max="2000000"
                              (input)="
                                setInvestmentValue2($event);
                                preventInput($event);calculation2();updateChartData2(chartData)
                              "
                            />
                          </div>
                        </div>
                        <div class="month_range">
                         <div
                              class="calculator-range-slider calculator-custom-range"
                            >
                              <input
                                type="range"
                                name=""
                                step="500"
                                value="25000"
                                class="input-range calc-result-sliders"
                                min="500"
                                max="2000000"
                                 id="monthlyRange"
                                [(ngModel)]="L_Monthly_investment"
                                (input)="monthlyInvestmentRangeVal2()"
                                (change)="calculation2(); updateChartData2(chartData)"
                              />
                              <span
                              class="type-range"
                              [style.width.%]="(LP / 2000000) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(LP / 2000000) * 100"
                            ></span>
                            </div>
                          <div class="values">
                            <p class="value">₹500</p>
                            <p class="value">₹20,00,000</p>
                          </div>
                        </div>


                  
                      </div>
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Expected return rate (p.a)</p>
                          <div class="tooltiped" id="error_msg1">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              L_Expected_Rate_error
                            }}</span>
                          </div>
                          <div class="placeholder reverse">
                            <i class="percent">%</i>
                            <input
                              class="range__amount"
                              id="monthlyexpect"
                              type="number"
                              value="12"
                              min="1"
                              max="30"
                              [(ngModel)]="L_monthlyexpect"
                              (input)="
                                setRateValue2($event);
                                preventInput($event);calculation2();updateChartData2(chartData)
                              "
                              
                            />
                          </div>
                        </div>
                        <div class="month_range">
                          <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              step="0.1"
                              class="input-range calc-result-sliders"
                              min="1"
                              max="30"
                              id="monthlyrate"
                              [(ngModel)]="L_monthlyexpect"
                              (input)="monthlyRateRangeVal2()"
                              (change)="calculation2(); updateChartData2(chartData)"
                            />
                            <span
                              class="type-range"
                              [style.width.%]="(LR / 30) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(LR / 30) * 100"
                            ></span>
                          </div>
                          <div class="values">
                            <p class="value">1%</p>
                            <p class="value">30%</p>
                          </div>
                        </div>
                      </div>
                      <div class="monthly">
                        <div class="month_heading">
                          <p class="text">Time period</p>
                          <div class="tooltiped" id="error_msg2">
                            <span class="material-icons-outlined icon"> info </span>
                            <span class="tooltiptext tooltip-top">{{
                              L_Time_period_error
                            }}</span>
                          </div>
                          <div class="placeholder reverse">
                            <i class="year">Yr</i>
                            <input
                              class="range__amount"
                              id="timeperiod"
                              type="number"
                              value="10"
                              min="1"
                              max="30"
                              [(ngModel)]="L_timeperiod"
                              (input)="
                                setTimeValue2($event);
                                preventInput($event);calculation2();updateChartData2(chartData)
                              "
                              
                            />
                          </div>
                        </div>
                        <div class="month_range">
                          <div
                            class="calculator-range-slider calculator-custom-range"
                          >
                            <input
                              type="range"
                              name=""
                              id="timerange"
                              step="1"
                              value="10"
                              class="input-range calc-result-sliders"
                              min="1"
                              max="30"
                              [(ngModel)]="L_timeperiod"
                              (input)="monthlyTimeRangeVal2()"
                              (change)="calculation2(); updateChartData2(chartData)"
                            />
                            <span
                              class="type-range"
                              [style.width.%]="(LT / 30) * 100"
                            ></span>
                            <span
                              class="thumb thumbNew"
                              [style.left.%]="(LT / 30) * 100"
                            ></span>
                          </div>
                          <div class="values">
                            <p class="value">1Yr</p>
                            <p class="value">30Yr</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="data">
                    <div class="graph">
                      <ul class="indicators">
                        <li class="amount">Invested amount</li>
                        <li class="return">Est. returns</li>
                      </ul>
                      <div class="graph_img">
                        <canvas id="myChart" width="260px" height="150px"></canvas>
                        <!-- <img src="../../../assets/images/wish-sip/graph.png" class="img-fluid" alt="graph"> -->
                      </div>
                      <div class="values">
                        <ul class="list">
                          <li class="text">Invested amount:</li>
                          <li class="value">
                            ₹{{ L_total_investment_ammount | conversions }}
                          </li>
                          <li class="text">Est. returns:</li>
                          <li class="value">
                            ₹{{ L_estmated_return | conversions }}
                          </li>
                        </ul>
                        <ul class="list total">
                          <li class="text">Total value:</li>
                          <li class="value">
                            ₹{{ L_calculate_value | conversions }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="invest_btn">
                            <a (click)="scrolltop()" style="cursor: pointer;">
                            <img src="../../../assets/images/wish-sip/Connect-Now-Button.png" alt="Invest Now" style="height:80px;" />
                            </a>
                    </div>
                  </div>
                </div>
                <!-- <div class="lumpsum"></div> -->
              </div>
            </div>
      
          </div>
        </div>
    </div>

</section>



<div class="container">
  <p class="col-md-12 mt-3 terms"> <span style="font-weight: bold;">Disclaimer: </span>Bajaj Capital Limited (BCL) (CIN: U67120DL1965PLC004338) is a mutual fund distributor (ARN 0010) registered with AMFI. Registered Office: Mezzanine Floor, Bajaj House 97, Nehru Place, New Delhi-110019.
    <b>Mutual Fund investments are subject to market risk, read all scheme-related documents carefully.</b> Certain products and services offered by BCL may not be traded on the exchange. All disputes with respect to the distribution activity, would not have access to Exchange Investor Redressal Forum or Arbitration mechanism. In accordance with the applicable laws, BCL is allowed to render incidental advice with respect to mutual fund products only to its mutual fund distribution clients. For every other purpose, including distribution of non-mutual fund products, the circulated material is for informational purposes only. Further, it is not intended as investment advice or an opinion concerning securities or a public offer proving a basis for an investment decision. The views or expressions contained in the circulated material are not necessarily of BCL and BCL neither assumes any responsibility/liability nor does guarantee its accuracy, suitability, completeness and adequacy. The figures and data that may be appearing in the material are taken from various sources and BCL is not responsible for the accuracy of the same. The content of the material including images, charts, graphics and pictures are protected intellectual properties and cannot be amended, copied, reproduced, replicated, republished, uploaded, posted, published, transmitted, displayed or distributed for any non-personal use without obtaining prior written permission, any non-adherence of which may attract appropriate legal action. The past performance of the scheme is not indicative of future performance. Investors are advised to seek appropriate advice from experts before taking any investment decisions. Nothing in the circulated material is intended to construe an advertisement or an investment, financial advice and/or solicitation, advice to buy, sell or deal in any financial product.
    </p>
    </div>
    
    <div class="new-section">
      <p>www.BajajCapital.com</p>
    </div>